import { ADD_GREEN_REGIONS } from '../constants/ActionTypes'

export function addMultiple(payload) {
  return { type: ADD_GREEN_REGIONS, payload }
}
